export default __webpack_public_path__ + "static/media/info.8bd6c290.svg";